module.exports = __webpack_public_path__ + "static/img/blue-1.dffe98a4.jpg";